module.exports = __webpack_public_path__ + "img/e_2_4_r.4bf9f203.png";